export default __webpack_public_path__ + "static/media/teddy.e37ea124.jpg";